/**
 * 🧭 A ORDEM DOS GRUPOS DO MENU — uma por casa.
 *
 * Vivia dentro do `Layout.tsx` como uma lista só. Saiu de lá em 24/08 por dois
 * motivos que se somaram: o arquivo bateu no teto do portão de tamanho, e a
 * ordem virou DADO de duas casas — dado puro merece arquivo puro, testável sem
 * renderizar a sidebar inteira.
 *
 * 🔒 POR QUE DUAS LISTAS, E NÃO UMA COM EXCEÇÃO: o menu é COMPARTILHADO entre
 * M5/Átomo e Regula. A ordem que conta a história da Regula (auditoria acha o
 * dinheiro → financeiro fatura) não é a que serve ao M5, onde o Financeiro é um
 * módulo inteiro e a Comunicação é fluxo de trabalho, não apoio. Arrumar uma
 * casa mexendo na ordem de todas seria mudar a casa do vizinho pra resolver um
 * problema que só existe aqui.
 *
 * Grupo que não estiver na lista vai pro fim, na ordem em que aparecer no NAV —
 * então um grupo novo nunca some do menu por esquecimento, ele só fica no fim.
 */

/** A ordem histórica do M5/Átomo. NÃO mexer pra arrumar a Regula. */
export const ORDEM_GRUPOS_M5 = [
  "VISÃO GERAL",
  "COMUNICAÇÃO",
  "DIAGNÓSTICO & MONITORAMENTO",
  "REGULARIZAÇÃO",
  "AUDITORIA E RECUPERAÇÃO",
  "AUDITORIA DE BOLETOS",
  "COMERCIAL",
  "OPERAÇÃO",
  "PESSOAS",
  "FINANCEIRO",
  "SOCIETÁRIO",
  "BASE",
  "RECURSOS",
  "SISTEMA",
  "EM BREVE",
] as const;

/**
 * A ordem da Regula (decisão do dono, 24/08) — a leitura de cima pra baixo é o
 * fluxo do serviço:
 *
 *   Torre abre o dia → CARTEIRA é o cadastro-base → DIAGNÓSTICO trabalha
 *   (Documentos → Vencimentos → Mesa → Requisitos) → AUDITORIA acha o dinheiro →
 *   FINANCEIRO fatura o que ela recuperou → COMERCIAL vende o próximo →
 *   apoio (Comunicação · Pessoas · Recursos · Sistema) fecha embaixo.
 *
 * As duas diferenças contra o M5: FINANCEIRO sobe (encosta na Auditoria, porque
 * achado → recuperado → faturado é UMA história) e COMUNICAÇÃO desce (Mensagens
 * é do grupo, não do fluxo Regula).
 */
export const ORDEM_GRUPOS_REGULA = [
  "VISÃO GERAL",
  "CARTEIRA",
  "DIAGNÓSTICO & MONITORAMENTO",
  "REGULARIZAÇÃO",
  "AUDITORIA E RECUPERAÇÃO",
  "AUDITORIA DE BOLETOS",
  "FINANCEIRO",
  "COMERCIAL",
  "OPERAÇÃO",
  "COMUNICAÇÃO",
  "PESSOAS",
  "SOCIETÁRIO",
  "BASE",
  "RECURSOS",
  "SISTEMA",
  "EM BREVE",
] as const;

/** Os slugs que usam a ordem da Regula — FALLBACK pra quem ainda não carrega `marca`. */
export const SLUGS_REGULA = ["regula360", "vitrine-reg"] as const;

/**
 * A ordem de grupos desta empresa. 05/09 (bloqueio 10): decide pela MARCA (dado) quando ela
 * vem; slug é fallback. Desconhecido → a ordem do M5 (o padrão da casa).
 */
export function ordemDosGrupos(empresaSlug: string | undefined | null, marca?: string | null): readonly string[] {
  const regula = marca ? marca === "regula" : (SLUGS_REGULA as readonly string[]).includes(empresaSlug ?? "");
  return regula ? ORDEM_GRUPOS_REGULA : ORDEM_GRUPOS_M5;
}
